import { render } from "./SwitchablePropertyCard.vue?vue&type=template&id=7e54388e&ts=true"
import script from "./SwitchablePropertyCard.vue?vue&type=script&lang=ts"
export * from "./SwitchablePropertyCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__